<div class="forms-container">
  <div class="form-section attachment-section">
    <form [formGroup]="form" (ngSubmit)="submit()" id="attachment-form">
      <div class="row">
        <div class="col-12">
          <app-bs-alert
            [importance]="Info"
            [showCloseButton]="true"
            key="trEsAttachmentsFileInfo"
            [alert]="{ display: true }"
          >
          </app-bs-alert>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <p class="text-muted">* {{ 'trAsteriskHelpText' | translate }}</p>
        </div>
      </div>

      <div class="row" formArrayName="Attachments">
        <div
          class="col-12 attachment-group"
          *ngFor="let attachment of attachments; let i = index"
        >
          <label>
            <app-rendering-html
              [id]="'attachmentType' + i"
              class="d-inline-block"
              [dynamicHtml]="isArabic ? attachment.nameAr : attachment.nameEn"
            ></app-rendering-html>
            <span
              class="d-inline-block mx-1"
              *ngIf="attachment.isRequired"
              style="color: red"
            >
              *</span
            ></label
          >
          <div
            class="attachment-upload"
            [class.justify-content-center]="
              attachment.instances == null || attachment.instances.length == 0
            "
            [class.attachment-required]="
              showValidation &&
              attachment.isRequired &&
              (attachment.instances == null || attachment.instances.length == 0)
            "
          >
            <div
              class="attachment-instance"
              *ngFor="let instance of attachment.instances; let i = index"
            >
              <div class="attachment-uploaded">
                <img
                  class="img-fluid"
                  src="./../../../../../assets/Images/go_digital.png"
                  alt="File Uploaded"
                />
              </div>
              <div [innerText]="instance.fileName"></div>
              <div class="justify-content-center">
                <div class="list-group-item-options">
                  <a
                    class="ds-btn-icon"
                    (click)="download(instance.fileId)"
                    (keydown.enter)="download(instance.fileId)"
                    title="{{ 'trViewFile' | translate }}"
                    tabindex="0"
                    role="button"
                    [attr.aria-label]="'trViewFile' | translate"
                  >
                    <i class="fi-view fi-large mx-2"></i>
                  </a>
                  <a
                    class="ds-btn-icon"
                    (click)="removeFileInstance(attachment, instance)"
                    (keydown.enter)="removeFileInstance(attachment, instance)"
                    title="{{ 'trDeleteFile' | translate }}"
                    tabindex="0"
                    role="button"
                    [attr.aria-label]="'trDeleteFile' | translate"
                  >
                    <i class="fi-close fi-large mx-2"></i>
                  </a>
                </div>
              </div>
            </div>

            <ngx-file-drop
              *ngIf="attachment.instances?.length < MAX_COUNT_OF_ATTACHMENTS"
              dropZoneLabel=""
              [browseBtnLabel]="'Browse Button'"
              browseBtnClassName="browse-btn-class"
              [multiple]="false"
              [accept]="ALLOWED_EXTENSIONS"
              [showBrowseBtn]="false"
              (onFileDrop)="
                onFileDrop($event, attachment.procedureAttachmentId)
              "
            >
              <ng-template
                ngx-file-drop-content-tmp
                let-openFileSelector="openFileSelector"
              >
                <button
                  type="button"
                  (click)="handleUploadFilesButtonClick(openFileSelector)"
                  class="ds-btn ds-btn-primary"
                  [innerText]="'UploadFile' | translate"
                  tabindex="0"
                  [attr.aria-labelledby]="'attachmentType' + i"
                ></button>
              </ng-template>
            </ngx-file-drop>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="form-section" *ngIf="showMainButtons">
    <app-es-main-buttons
      (action)="actionHandler($event)"
      [buttons]="buttons"
    ></app-es-main-buttons>
  </div>
</div>
